import API from "../constants/api.constant";
import { responseErrorHandling } from "../helper/common.helper";
import axiosInstance from "./axiosInstance";

export const createBanker = async (payload: Object) => {
  try {
    const response = await axiosInstance.post(
      API.CREATE_BANKER_PROFILE,
      payload
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const importBankers = async (file: File, businessId: string) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("businessId", businessId);

    const response = await axiosInstance.post(API.IMPORT_BANKERS, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const getBankers = async (payload: Object) => {
  try {
    const response = await axiosInstance.get(API.GET_ALL_BANKER, {
      params: payload,
    });
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const deleteBankerById = async (id: string) => {
  try {
    const response = await axiosInstance.delete(API.DELETE_BANKER + id);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

export const updateBanker = async (id:string, payload: object) => {
    try {
    const response = await axiosInstance.patch(API.UPDATE_BANKER + id, payload);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

export const blockBanker = async (id:string, payload: object) => {
    try {
    const response = await axiosInstance.patch(API.BLOCK_BANKER + id, payload);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
}

// change banker password
export const changeBankerPassword = async ( id: string, data: object) => {
 try {
  const response = await axiosInstance.put(API.BANKER_PASSWORD_CHANGE_ENDPOINT + id, data);
  return response.data;
 } catch (error:any) {
  responseErrorHandling(error)
 }
}

// get banker profile
export const getBankerProfile = async ( id: string) => {
 try {
  const response = await axiosInstance.get(API.GET_BANKER_PROFILE + id);
  return response.data;
 } catch (error:any) {
  responseErrorHandling(error)
 }
}

// update banker profile
export const updateBankerProfile = async (id: string, data: object) => {
 try {
  const response = await axiosInstance.patch(API.UPDATE_BANKER + id, data);
  return response.data;
 } catch (error:any) {
  responseErrorHandling(error)
 }
}

// banker invitations link
export const bankerInvitationLink = async (businessId: string) => {
 try {
   const response = await axiosInstance.get(API.BANKER_INVITATION_LINK + businessId);
   return response.data;
 } catch (error) {
    responseErrorHandling(error)
 }
}

// send banker registration invite
export const sendRegisterInvitationBanker = async (data: object) => {
  try {
   const response = await axiosInstance.post(API.SEND_REGISTER_INVITE_BANKER, data);
   return response.data;
  } catch (error) {
    responseErrorHandling(error)
  }
}

// get banker registration details
export const getBankerRegistration = async () => {
  try {
   const response = await axiosInstance.get(API.GET_BANKER_REGISTER);
    return response.data;
  } catch (error) {
    responseErrorHandling(error)
  }
}

// create banker registration
export const createBankerRegistration = async (data: object) => {
  try {
   const response = await axiosInstance.post(API.CREATE_BANKER_REGISTER, data);
    return response.data;
  } catch (error) {
    responseErrorHandling(error)
  }
}

// get banker assigned deals
export const getBankerAssignedDeals = async (params: { search?: string; dealType?: string; sortBy?: string; sortOrder?: string; status?: string }) => {
  try {
    const response = await axiosInstance.get(API.GET_BANKER_ASSIGNED_DEALS, { params });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// get banks
export const getBanks = async () => {
  try {
    const response = await axiosInstance.get(API.GET_BANKS);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// create bank
export const createBank = async (name: string) => {
  try {
    const response = await axiosInstance.post(API.CREATE_BANK, { name });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// update banker interest status
export const updateBankerInterest = async (dealId: string, bankerId: string, interestStatus: string) => {
  try {
    const response = await axiosInstance.patch(`${API.UPDATE_BANKER_INTEREST}${dealId}/banker/${bankerId}/interest`, { interestStatus });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// get banker deal details
export const getBankerDealDetails = async (dealId: string) => {
  try {
    const response = await axiosInstance.get(`${API.GET_BANKER_DEAL_DETAILS}${dealId}`);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// create banker document
export const createBankerDocument = async (formData: FormData) => {
  try {
    const response = await axiosInstance.post(API.CREATE_BANKER_DOCUMENT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// get banker documents for a deal
export const getBankerDocuments = async (dealId: string) => {
  try {
    const response = await axiosInstance.get(`${API.GET_BANKER_DOCUMENTS}${dealId}`);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// delete banker document
export const deleteBankerDocument = async (id: string) => {
  try {
    const response = await axiosInstance.delete(`${API.DELETE_BANKER_DOCUMENT}${id}`);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// create term sheet
export const createTermSheet = async (data: any) => {
  try {
    const response = await axiosInstance.post(API.CREATE_TERM_SHEET, data);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// get term sheet
export const getTermSheet = async (dealId: string) => {
  try {
    const response = await axiosInstance.get(`${API.GET_TERM_SHEET}${dealId}`);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// update term sheet
export const updateTermSheet = async (id: string, data: any) => {
  try {
    const response = await axiosInstance.put(`${API.UPDATE_TERM_SHEET}${id}`, data);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}

// get banker documents by banker
export const getBankerDocumentsByBanker = async (dealId: string, bankerId: string) => {
  try {
    const response = await axiosInstance.get(`${API.GET_BANKER_DOCUMENTS_BY_BANKER}${dealId}/${bankerId}`);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
}
